import * as Yup from 'yup';

const FormValidation = Yup.object({
  name: Yup.string().required('Name is Required'),
  title: Yup.string(),
  email: Yup.string().email('Invalid email').required('Email is Required'),
  birth_date: Yup.ref('dateSale'),
  citizenship: Yup.string(),
  country: Yup.string(),
  home_phone: Yup.string()
    .matches(
      /(\+\d{1,3}\s?)?((\(\d{3}\)\s?)|(\d{3})(\s|-?))(\d{3}(\s|-?))(\d{4})(\s?(([E|e]xt[:|.|]?)|x|X)(\s?\d+))?/g,
      'Telephone must contain the country code and the number'
    ),
  cell: Yup.string()
      .matches(
          /(\+\d{1,3}\s?)?((\(\d{3}\)\s?)|(\d{3})(\s|-?))(\d{3}(\s|-?))(\d{4})(\s?(([E|e]xt[:|.|]?)|x|X)(\s?\d+))?/g,
          'Telephone must contain the country code and the number'
      ),
  name_of_organization: Yup.string().required('Name of organization is Required'),
  position: Yup.string().required('Position is Required'),
  type_of_medium: Yup.string(),
  web_address: Yup.string(),
  address: Yup.string(),
  apt: Yup.string(),
  city: Yup.string(),
  state: Yup.string(),
  zip: Yup.string(),
  org_country: Yup.string(),
  org_phone: Yup.string()
      .matches(
      /(\+\d{1,3}\s?)?((\(\d{3}\)\s?)|(\d{3})(\s|-?))(\d{3}(\s|-?))(\d{4})(\s?(([E|e]xt[:|.|]?)|x|X)(\s?\d+))?/g,
      'Telephone must contain the country code and the number'
  ),
  ex: Yup.string(),
  chief_editor_name: Yup.string(),
  chief_editor_phone:  Yup.string()
      .matches(
          /(\+\d{1,3}\s?)?((\(\d{3}\)\s?)|(\d{3})(\s|-?))(\d{3}(\s|-?))(\d{4})(\s?(([E|e]xt[:|.|]?)|x|X)(\s?\d+))?/g,
          'Telephone must contain the country code and the number'
      ),
  chief_editor_email: Yup.string().email('Invalid email')
});

export default FormValidation;
